import { PillButton, typographyHelper } from '@construct-kit/core';
import styled, { css } from 'styled-components';

export const StyledPillButton = styled(PillButton)<{ isOpen?: boolean }>`
  flex-grow: 0;
  ${typographyHelper('subtitle02')};
  padding: 0.3125rem 0.9375rem;
  min-height: 2rem;
  min-width: 2rem;

  ${({ isOpen }) =>
    isOpen &&
    css`
      > svg {
        ${isOpen ? 'transform: rotate(-180deg)' : ''};
        transition: transform 0.2s;
      }
    `}

  ${({ theme }) => css`
    ${theme.layoutBreakpoints.extraLarge} {
      ${typographyHelper('subtitle01')};
      padding: 0.4375rem 1.4375rem;
      min-height: 2.5rem;
      min-width: 2.5rem;
    }
  `}
`;

export const ResponsiveIconPillButton = styled(StyledPillButton)`
  > span {
    display: none;
  }

  ${({ theme }) => css`
    ${theme.layoutBreakpoints.large} {
      > span {
        display: inline;
      }
    }
  `}
`;
